import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  code: z.string().optional().default(''),
});

export const Route = createFileRoute('/_layoutAuth/_guest/email-response/')({
  validateSearch: searchSchema,
});
